/* @flow */
import * as React from 'react';

import Glyph from 'components/Glyph.jsx';

import {
  ComposableTable,
  getTextCellGenerator,
  getTimestampCellGenerator,
  getGlyphCellGenerator,
} from 'components/ComposableTable';

// TODO: this is placeholder data
const DUMMY_DATA = [
  {
    uuid: 'uuid-1',
    name: 'Jason Winters',
    rostered: false,
    lastAnnouncementSent: 1481917457,
    classes: 4,
  },
  {
    uuid: 'uuid-2',
    name: 'Dane Natoli',
    rostered: true,
    lastAnnouncementSent: 1549992128498,
    classes: 5,
  },
  {
    uuid: 'uuid-3',
    name: 'Ben Guillet',
    rostered: false,
    lastAnnouncementSent: 1544228828498,
    classes: 1,
  },
  {
    uuid: 'uuid-4',
    name: 'Felix Mo',
    rostered: true,
    lastAnnouncementSent: 1939393128498,
    classes: 2,
  },
  {
    uuid: 'uuid-5',
    name: 'Aiden Zucker',
    rostered: true,
    lastAnnouncementSent: 1544999128498,
    classes: 4,
  },
  {
    uuid: 'uuid-6',
    name: 'John Shin',
    rostered: false,
    lastAnnouncementSent: 1544552000000,
    classes: 3,
  },
  {
    uuid: 'uuid-7',
    name: 'Nikki Galusha',
    rostered: true,
    lastAnnouncementSent: 1923552128498,
    classes: 9,
  },
  {
    uuid: 'uuid-8',
    name: 'Edith Chao',
    rostered: false,
    lastAnnouncementSent: 1500002128498,
    classes: 3,
  },
];

export default class PeopleListTableDataContainer extends React.Component<$FlowFixMeProps> {
  // TODO: define real prop types
  // TODO: dynamically build headers and generators based on the data coming in
  render() {
    const columnHeaders = ['Name', 'Source', 'Last Announcement Sent', 'Classes'];
    const columnGenerators = [
      getTextCellGenerator('name'),
      getGlyphCellGenerator('rostered', {
        true: <Glyph name="link" color="shamrock" size="large" solo />,
        false: <Glyph name="link" color="koala" size="large" solo />,
      }),
      getTimestampCellGenerator('lastAnnouncementSent'),
      getTextCellGenerator('classes'),
    ];

    return (
      <ComposableTable
        columnHeaders={columnHeaders}
        columnGenerators={columnGenerators}
        rows={DUMMY_DATA}
        keyField="uuid"
      />
    );
  }
}
